import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'cuadrante',
})
export class CuadrantePipe implements PipeTransform {

  transform(items: any[], filter: any[]) {

    if (filter && items) {

      if (filter['id_usuario']) {

        items = items.filter(function (item) {
          return item.id_usuario == filter['id_usuario'];
        });
      }


      if (filter['id_local'] && filter['id_local'] > 0) {

        items = items.filter(function (item) {
          return item.id_local == filter['id_local'];
        });
      }

      if (filter['id_departamanto'] && filter['id_departamanto'] > 0) {

        items = items.filter(function (item) {
          return item.id_departamento == filter['id_departamanto'];
        });
      }

      if (filter['id_servicio'] && filter['id_servicio'] > 0) {

        items = items.filter(function (item) {
          return item.id_servicio == filter['id_servicio'];
        });
      }




    }

    return items;
  }

}



// WEBPACK FOOTER //
// ./src/pipes/cuadrante/cuadrante.ts